// extracted by mini-css-extract-plugin
module.exports = {"table":"ApplicationsTable_table__2_SeA","totalColumnHeadCell":"ApplicationsTable_totalColumnHeadCell__20Jr8"};